import { render, staticRenderFns } from "./organogram.vue?vue&type=template&id=1bebd7ba&scoped=true"
import script from "./organogram.vue?vue&type=script&lang=js"
export * from "./organogram.vue?vue&type=script&lang=js"
import style0 from "./organogram.vue?vue&type=style&index=0&id=1bebd7ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bebd7ba",
  null
  
)

export default component.exports